import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";
import axiosInstance from "../axiosConfig";

const LotIdStatusupdate = () => {
  const [lotRecords, setLotRecords] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const fetchLotUploadData = async () => {
    try {
      const res = await axiosInstance.get("/api/get-lotUploadOrNot");
      setLotRecords(res.data);
    } catch (err) {
      console.error("Error fetching lot upload data:", err);
    }
  };

  useEffect(() => {
    fetchLotUploadData();
  }, []);

  const handleStatusChange = async (id, newStatus) => {
    try {
      await axiosInstance.patch(`/api/update-lotUploadOrNot/${id}`, {
        uploadStatus: newStatus,
      });
      fetchLotUploadData(); // refresh table
    } catch (err) {
      console.error("Failed to update status:", err);
      showAlert("❌ Failed to update status");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      await axiosInstance.delete(`/api/delete-lotUploadOrNot/${id}`);
      fetchLotUploadData(); // refresh table
    } catch (err) {
      console.error("Failed to delete record:", err);
      showAlert("❌ Failed to delete record");
    }
  };

  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 2000);
  };

  const columns = [
    { name: "LOT ID", selector: (row) => row["LOT ID"], sortable: true },
    { name: "Description", selector: (row) => row.DESCRIPTION, sortable: true },
    {
      name: "Link",
      selector: (row) => (
        <a href={row.LINK} target="_blank" rel="noopener noreferrer">
          View
        </a>
      ),
    },

    // {
    // name: "Status",
    // width: "100px",
    // selector: (row) => row["UPLOAD STATUS"] || "N/A",
    // sortable: true,
    // cell: (row) => {
    //     const status = row["UPLOAD STATUS"] || "N/A";
    //     let bgColor = "transparent";
    //     let textColor = "black";
    //     let textbold = "normal";       // ← initialize here

    //     if (status === "Uploaded") {
    //     bgColor = "green";
    //     textColor = "white";
    //     textbold = "bold";
    //     } else if (status === "Pending") {
    //     bgColor = "#fff3cd";
    //     textColor = "#856404";
    //     textbold = "bold";          // now this will work
    //     }

    //     return (
    //     <span
    //         style={{
    //         backgroundColor: bgColor,
    //         color: textColor,
    //         borderRadius: "4px",
    //         display: "inline-block",
    //         padding: "2px 2px",
    //         minWidth: "60px",
    //         textAlign: "center",
    //         fontWeight: textbold,    // uses the declared variable
    //         }}
    //     >
    //         {status}
    //     </span>
    //     );
    // },
    // },
    {
      name: "Updated Status",
      selector: (row) => row["UPLOAD STATUS"] || "N/A",
      cell: (row) => (
        <select
          value={row["UPLOAD STATUS"] || "Pending"}
          onChange={(e) => handleStatusChange(row.ID, e.target.value)}
          className="form-select form-select-sm"
          style={{
        backgroundColor:
          row["UPLOAD STATUS"] === "Completed"
            ? "green"
            : row["UPLOAD STATUS"] === "Uploaded"
            ? "orange"
            : "#125d9aff",
        color:
          row["UPLOAD STATUS"] === "Uploaded"
            ? "black"
            : "white",
        fontWeight: "bold"
      }}

        >
        
          <option value="Pending">Pending</option>
          <option value="Uploaded">Uploaded</option>
        <option value="Completed">Completed</option>
        </select>
      ),
      sortable: true,
    },
    {
      name: "Upload Time",
      selector: (row) => row.Uploaded_Time || "N/A",
      sortable: true,
    },

    { name: "Uploaded Date", selector: (row) => row.DATE, sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <button
          className="btn btn-sm btn-danger"
          onClick={() => handleDelete(row.ID)}
        >
          Delete
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div className="d-flex">
      <div
        className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}
      >
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header
          toggleSidebar={toggleSidebar}
          isSidebarVisible={isSidebarVisible}
        />
        <main className="main-container p-4" style={{ height: "-webkit-fill-available" }}>
          <div id="alertPlaceholder"></div>
          <div className="d-flex justify-content-end mb-3"></div>
          <DataTable columns={columns} data={lotRecords} pagination />
        </main>
      </div>
    </div>
  );
};

export default LotIdStatusupdate;
